module.exports = __webpack_public_path__ + "media/configurations/P-X-X-7edbe5a1.png";